import { useEffect, useState } from 'react';
import { EventOccurrenceDetails, EventOccurrenceSummary } from './EventOccurrencePresentation';
import type { AnalyticsEventRecord } from './types';

export function SessionEventTimeline(props: { events: AnalyticsEventRecord[] }): React.JSX.Element {
  const [selectedEventId, setSelectedEventId] = useState<string | null>(null);
  const orderedEvents = [...props.events];
  orderedEvents.sort(compareEventsNewestFirst);

  useEffect(() => {
    setSelectedEventId(null);
  }, [props.events]);

  return <>{orderedEvents.map((event) => <EventTimelineEntry key={event.eventId} event={event} selected={event.eventId === selectedEventId} onToggle={toggleEvent} />)}</>;

  function toggleEvent(eventId: string): void {
    setSelectedEventId(selectedEventId === eventId ? null : eventId);
  }
}

function compareEventsNewestFirst(left: AnalyticsEventRecord, right: AnalyticsEventRecord): number {
  if (left.clientTime === right.clientTime) {
    return right.sequence - left.sequence;
  }
  return left.clientTime < right.clientTime ? 1 : -1;
}

function EventTimelineEntry(props: { event: AnalyticsEventRecord; selected: boolean; onToggle: (eventId: string) => void }): React.JSX.Element {
  const event = props.event;
  const detailsId = `event-details-${event.eventId}`;
  return (
    <div className={props.selected ? 'event-row selected' : 'event-row'}>
      <button className="event-row-trigger" type="button" aria-expanded={props.selected} aria-controls={detailsId} onClick={() => props.onToggle(event.eventId)}>
        <EventOccurrenceSummary event={event} variant="timeline" />
        <span className="event-row-actions">{event.clockSkewed && <span className="warning">clock</span>}<span className="event-detail-toggle">{props.selected ? 'Hide details' : 'Details'}</span></span>
      </button>
      {props.selected && <EventOccurrenceDetails event={event} variant="inline" id={detailsId} />}
    </div>
  );
}
